import React, { useState, useEffect } from 'react';
import { API } from '../../App';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, Clock, GraduationCap, Users } from 'lucide-react';
import { MeetingLinkButton } from './BookingGroupPanel';
import { fmtDate, endTime } from '../../lib/apiError';

const JoinedSessions = ({ onCount }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/sessions/joined`)
      .then((r) => { setItems(r.data || []); onCount?.((r.data || []).length); })
      .catch((e) => console.debug('JoinedSessions: load failed', e));
  }, [onCount]);

  if (items.length === 0) return null;

  return (
    <div className="mt-12" data-testid="joined-sessions">
      <h2 className="text-lg font-bold text-slate-900 mb-1">Sessions I've Joined</h2>
      <p className="text-sm text-slate-500 mb-4">Group sessions other students booked and accepted you into. No payment needed from you.</p>
      <div className="space-y-3">
        {items.map((s) => (
          <Card key={s.id} className="border-0 shadow-md" data-testid={`joined-session-${s.id}`}>
            <CardContent className="p-5 flex flex-col md:flex-row md:items-center gap-4 justify-between">
              <div className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold text-slate-900">{s.subject}</h3>
                  {s.booking_status === 'cancelled' && <Badge className="bg-rose-100 text-rose-700 border-rose-300">Cancelled</Badge>}
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-slate-600">
                  <span className="flex items-center gap-1.5"><GraduationCap className="w-4 h-4" />{s.teacher_name}</span>
                  <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4" />{fmtDate(s.booking_date)}</span>
                  <span className="flex items-center gap-1.5"><Clock className="w-4 h-4" />{s.start_time}–{endTime(s.start_time, s.duration_hours)}</span>
                  <span className="flex items-center gap-1.5"><Users className="w-4 h-4" />Hosted by {s.host_name} · {s.filled}/{s.group_size}</span>
                </div>
              </div>
              {s.meeting_link ? (
                <MeetingLinkButton link={s.meeting_link} testId={`joined-meeting-link-${s.id}`} />
              ) : s.booking_status !== 'cancelled' ? (
                <span className="text-xs text-slate-500" data-testid={`joined-link-pending-${s.id}`}>Meeting link will appear here soon</span>
              ) : null}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default JoinedSessions;
